export { PlpPagination } from "./PlpPagination";
export type { PlpPaginationProps } from "./PlpPagination";
